"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandFixtures = void 0;
exports.brandFixtures = {
    id: "SG9sZGluZzoxNDI=",
    brand: "EUREST",
    importationType: "OSCARE",
};
